export default "__VITE_ASSET__Bi5J6Ecq__"